// extracted by mini-css-extract-plugin
export var noSpinners = "_ml-6";
export var percentageInput = "_ml-7";
export var variantColor1 = "_ml-0";
export var variantColor2 = "_ml-1";
export var variantColor3 = "_ml-2";
export var variantColor4 = "_ml-3";
export var variantColor5 = "_ml-4";
export var variantColor6 = "_ml-5";